import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

/**
 * Componente de Autocomplete para seleccionar ubicaciones
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.locations - Lista de ubicaciones disponibles
 * @param {number|string} props.value - ID de la ubicación seleccionada
 * @param {Function} props.onChange - Función a llamar cuando cambia la selección
 * @param {boolean} props.error - Indica si hay un error de validación
 * @param {string} props.helperText - Texto de ayuda o mensaje de error
 * @param {string} props.label - Etiqueta del campo (por defecto "Ubicación")
 * @returns {JSX.Element} Componente de Autocomplete
 */
const LocationAutocomplete = ({ 
  locations, 
  value, 
  onChange, 
  error, 
  helperText,
  label = "Ubicación"
}) => {
  // Encontrar la ubicación seleccionada
  const selectedLocation = locations.find(location => location.id === value) || null;
  
  return (
    <Autocomplete
      options={locations}
      getOptionLabel={(option) => 
        `${option.ubigeo} - ${option.department_name}, ${option.province_name}, ${option.district_name}`
      }
      value={selectedLocation}
      onChange={(event, newValue) => {
        onChange(newValue ? newValue.id : '');
      }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={Boolean(error)}
          helperText={helperText}
          fullWidth
        />
      )}
      fullWidth
    />
  );
};

export default LocationAutocomplete; 